import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation createUserRole($data: createUserRoleInput!) {
    createUserRole(data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const createUserRoleRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {data: TYPES.CreateUserRoleInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'user/create_user_role',
  async (params: {data: TYPES.CreateUserRoleInput;}, { extra: client }) => {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.createUserRole;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const createUserRoleSlice = createSlice({
  name: 'create_user_role',
  initialState: initialState,
  reducers: {
    createUserRoleClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(createUserRoleRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(createUserRoleRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(createUserRoleRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { createUserRoleClear } = createUserRoleSlice.actions;

export const createUserRole = createSelector(
  (state: RootState) => state.user.createUserRole.result,
  (state: RootState) => state.user.createUserRole.error,
  (state: RootState) => state.user.createUserRole.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default createUserRoleSlice.reducer;